import { render, staticRenderFns } from "./WorkspaceEntityColumn.vue?vue&type=template&id=f3d31fea&scoped=true"
import script from "./WorkspaceEntityColumn.vue?vue&type=script&lang=js"
export * from "./WorkspaceEntityColumn.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceEntityColumn.vue?vue&type=style&index=0&id=f3d31fea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d31fea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3d31fea')) {
      api.createRecord('f3d31fea', component.options)
    } else {
      api.reload('f3d31fea', component.options)
    }
    module.hot.accept("./WorkspaceEntityColumn.vue?vue&type=template&id=f3d31fea&scoped=true", function () {
      api.rerender('f3d31fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceEntityColumn.vue"
export default component.exports